<template>
    <b-modal
        id="modal-create-download-video"
        ref="modal-create-download-video"
        centered
        ok-title="Aceptar"
        ok-variant="primary"
        cancel-title="Cancelar"
        title="Agregar Nuevo Video de Youtube"
        :ok-disabled="disableOkButton"
        @ok="onCreate"
        @hidden="resetForm()"
    >
        <b-form id="video-form" @submit.stop.prevent="onSubmit()">
            <b-form-group
                id="input-group-download-video-name"
                label="*Nombre:"
                label-for="input-download-video-name"
            >
                <b-form-input
                    id="input-download-video-name"
                    v-model.trim="$v.form.name.$model"
                    name="name"
                    type="text"
                    required
                    placeholder="Nombre a mostrar"
                    :state="validateState('name')"
                    :disabled="formDisabled"
                />
                <b-form-invalid-feedback id="input-download-video-name-feedback">
                    <ul>
                        <li v-if="!$v.form.name.required">Este campo es requerido.</li>
                    </ul>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                id="input-group-download-video-url"
                label="*ID del Video:"
                label-for="input-download-video-url"
            >
                <b-alert show variant="light">
                    <p class="text-dark">
                        Actualmente solo se permiten ids de videos de <strong>Youtube</strong>.<br />
                        <u>Ejemplo:</u> En la dirección url del siguiente video de youtube:
                        <code>https://www.youtube.com/watch?v=F2jiu-_9glM</code><br />
                        El ID a colocar en el formulario sería: <code>F2jiu-_9glM</code><br />
                        Si el ID es correcto, podrá previsualizar su video abajo.
                    </p>
                </b-alert>
                <b-input-group prepend="https://www.youtube.com/watch?v=" class="mt-3">
                    <b-form-input
                        id="input-download-video-url"
                        v-model.trim="$v.form.url.$model"
                        name="url"
                        type="text"
                        required
                        placeholder="F2jiu-_9glM"
                        :state="validateState('url')"
                        :disabled="formDisabled"
                    />
                    <b-form-invalid-feedback id="input-download-video-url-feedback">
                        <ul>
                            <li v-if="!$v.form.url.required">Este campo es requerido.</li>
                        </ul>
                    </b-form-invalid-feedback>
                </b-input-group>
            </b-form-group>

            <label>Previsualización:</label>
            <LazyYoutubeVideo :src="`https://www.youtube.com/embed/${form.url}`" autoplay />

        </b-form>
    </b-modal>
</template>

<script>
import LazyYoutubeVideo from 'vue-lazy-youtube-video'
import { required } from 'vuelidate/lib/validators'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'VideoCreateFormModal',
    components: {
        LazyYoutubeVideo
    },
    data () {
        return {
            formDisabled: false,
            form: {
                name: '',
                url: ''
            }
        }
    },
    validations: {
        form: {
            name: {
                required
            },
            url: {
                required
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'getActiveSiteIdentifiers'
        ]),
        disableOkButton () {
            return this.formDisabled || this.$v.form.$invalid
        }
    },
    methods: {
        ...mapActions([
            'createSiteVideo',
            'readCourseSiteByAcademicPeriod'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async onCreate (bvModalEvt) {
            bvModalEvt.preventDefault() // Prevent modal from closing
            await this.onSubmit() // Trigger submit handler
        },
        resetForm () {
            this.form.name = ''
            this.form.url = ''
            this.$v.$reset()
        },
        async onSubmit () {
            let loader = null
            var payloadData
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                payloadData = { ...this.form, courseSiteId: this.activeSite.id }
                await this.createSiteVideo(payloadData)
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-create-download-video')
                })
                this.resetForm()
                // Reload the current active site data
                await this.readCourseSiteByAcademicPeriod({
                    courseCode: this.getActiveSiteIdentifiers.courseCode,
                    academicPeriod: this.getActiveSiteIdentifiers.academicPeriod
                })
                this.$root.successToast(`Video creado exitosamente.`)
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
